import { Injectable } from '@angular/core';
import { __ } from '@montblancsimpl/core';
import { Observable, Subject } from 'rxjs';

import { MbCarouselComponent } from './carousel.component';

@Injectable()
export class MbCarouselService<T> {
  private _isVisible$: Subject<boolean> = new Subject<boolean>();

  private _isVisible: boolean = false;

  isVisible$: Observable<boolean> = this._isVisible$.asObservable();

  get isVisible(): boolean {
    return this._isVisible;
  }

  private carousel: MbCarouselComponent<T>;

  constructor() {}

  init(carousel: MbCarouselComponent<T>): void {
    if (__.IsNullOrUndefined(this.carousel)) {
      this.carousel = carousel;
    }
  }

  setVisibility(visible: boolean): void {
    this._isVisible = visible;
    this._isVisible$.next(visible);
  }
}
